export enum SubscriptionType {
    FREE = 'FREE',
    STARTER = 'STARTER',
    SINGLE_USER = 'SINGLE_USER',
    POWER_USER = 'POWER_USER',
    TEAM = 'TEAM',
    EDUCATION = 'EDUCATION',
    UNLIMITED = 'UNLIMITED',
}

export enum CreditType {
    INCLUSIVE = 0,
    EXTRA = 1,
}

export enum SubscriptionChangeType {
    SUBSCRIPTION_END = 'SUBSCRIPTION_END',
    PERIOD_END = 'PERIOD_END',
}

export class ChangeSubscriptionRequestDto {
    subscriptionType: SubscriptionType;
    changeType: SubscriptionChangeType;
    prepaidPeriods?: number;
    isAutoRenew: boolean;
    trybUserId: string;
}

export class IncreaseCreditsRequestDto {
    amount: number;
    trybUserId: string;
    creditType: CreditType;
    creditExpirationDate: Date;
    cause: string;
}

export class DecreaseCreditsRequestDto {
    amount: number;
    trybUserId: string;
    cause: string;
    isSpend: boolean;
}

export interface CreditsOverviewDto {
    inclusive: number;
    extra: number;
    used: number;
    blocked: number;
    available: number;
    currentSubscription: SubscriptionDto;
    nextSubscription: SubscriptionDto;
}

export interface SubscriptionDto {
    subscriptionType: SubscriptionType;
    startDate: Date;
    endDate: Date;
    periodStartDate: Date;
    periodEndDate: Date;
    remainingPrepaidPeriods?: number;
    isAutoRenew: boolean;
    nextSubscriptionType?: SubscriptionType;
}

export interface Budget {
    inclusive: number;
    extra: number;
    used: number;
    blocked: number;
    available: number;
    isUnlimited: boolean;
    periodStartDate: string;
    periodEndDate: string;
}

export interface CreateCheckoutSessionDto {
    priceKey: string;
    promotionCode?: string;
}

export interface SessionUrlDto {
    url: string;
}
